import { defineStore } from 'pinia';
import LoginService from '../../../Services/LoginService';

export const useInventoryStore = defineStore({
  id: 'InventoryStore',
  state: () => ({
    value: 1,
    user: null,
    _country: [],
    _state: [],
    _city: [],
    MenuTab: null,
    SubTab: null
  }),

  getters: {
    getUser: (state) => state.user,
    getCountry: (state) => {
      if (state._country.length === 0) {
        const countryData: any = localStorage.getItem('country');
        if (countryData) {
          try {
            state._country = JSON.parse(countryData);
          } catch (error) {
            console.error('Error parsing country data from localStorage:', error);
            state._country = [];
          }
        }
      }
      return state._country;
    },
    getFetchedValue: (state) => {
      // Use a computed property to return the value after the action fetchMaster is executed
      let response = state.value; // use current value as fallback
      if (state.value !== null) {
        response = state.value;
      }
      return response;
    },
  },

  actions: {
    setNewValue(newValue: number) {
      this.value = newValue;
    },

    async fetchMaster() {
      try {
        const dataModel = {
          Dml_Indicator: 'C',
        };
        const response = await LoginService.GetCountry(dataModel);
        this.value = response.data
      } catch (error) {
        console.error(error);
      }
    },
  },
});
